// Calculate form completion progress based on filled fields
export const calculateFormProgress = (studyData, formData) => {
    // Safety checks
    if (!studyData || !studyData.sections || !Array.isArray(studyData.sections)) {
        console.warn('ProgressCalculator: Invalid studyData structure');
        return 0;
    }

    if (!formData || typeof formData !== 'object') {
        console.warn('ProgressCalculator: Invalid formData');
        return 0;
    }

    let totalRequiredFields = 0;
    let filledRequiredFields = 0;

    // Helper function to check if a field value is filled
    const isFieldFilled = (value) => {
        if (value === undefined || value === null || value === '') {
            return false;
        }
        if (Array.isArray(value) && value.length === 0) {
            return false;
        }
        return true;
    };

    // Helper function to process fields from subsections
    const processFields = (fields) => {
        if (!fields || !Array.isArray(fields)) {
            return;
        }

        fields.forEach(field => {
            // Only count required fields
            if (field.required) {
                // Check if field has showIf condition
                let shouldCount = true;

                if (field.showIf) {
                    const { field: conditionField, value: conditionValue } = field.showIf;
                    // Only count if condition is met
                    shouldCount = formData[conditionField] === conditionValue;
                }

                if (shouldCount) {
                    totalRequiredFields++;

                    if (isFieldFilled(formData[field.id])) {
                        filledRequiredFields++;
                    }
                }
            }
        });
    };

    // Process all sections
    studyData.sections.forEach(section => {
        // Check if section has subsections (new structure)
        if (section.subsections && Array.isArray(section.subsections)) {
            section.subsections.forEach(subsection => {
                if (subsection.fields) {
                    processFields(subsection.fields);
                }
            });
        }
        // Fallback: Check if section has direct questions (old structure)
        else if (section.questions && Array.isArray(section.questions)) {
            // Handle old structure for backward compatibility
            const processQuestions = (questions) => {
                questions.forEach(question => {
                    if (question.type === 'group' && question.questions) {
                        processQuestions(question.questions);
                    } else if (question.required) {
                        totalRequiredFields++;
                        if (isFieldFilled(formData[question.id])) {
                            filledRequiredFields++;
                        }
                    }
                });
            };
            processQuestions(section.questions);
        }
    });

    // Calculate percentage
    if (totalRequiredFields === 0) {
        return 0;
    }

    const progress = Math.round((filledRequiredFields / totalRequiredFields) * 100);

    console.log('Progress Calculation:', {
        totalRequired: totalRequiredFields,
        filled: filledRequiredFields,
        percentage: progress
    });

    return progress;
};

// Export additional helper if needed
export const getSectionProgress = (section, formData) => {
    if (!section) return 0;

    let totalRequired = 0;
    let filled = 0;

    const isFieldFilled = (value) => {
        if (value === undefined || value === null || value === '') return false;
        if (Array.isArray(value) && value.length === 0) return false;
        return true;
    };

    // Process subsections
    if (section.subsections && Array.isArray(section.subsections)) {
        section.subsections.forEach(subsection => {
            if (subsection.fields && Array.isArray(subsection.fields)) {
                subsection.fields.forEach(field => {
                    if (field.required) {
                        let shouldCount = true;

                        if (field.showIf) {
                            const { field: conditionField, value: conditionValue } = field.showIf;
                            shouldCount = formData[conditionField] === conditionValue;
                        }

                        if (shouldCount) {
                            totalRequired++;
                            if (isFieldFilled(formData[field.id])) {
                                filled++;
                            }
                        }
                    }
                });
            }
        });
    }
    // Fallback for old structure
    else if (section.questions && Array.isArray(section.questions)) {
        const processQuestions = (questions) => {
            questions.forEach(question => {
                if (question.type === 'group' && question.questions) {
                    processQuestions(question.questions);
                } else if (question.required) {
                    totalRequired++;
                    if (isFieldFilled(formData[question.id])) {
                        filled++;
                    }
                }
            });
        };
        processQuestions(section.questions);
    }

    return totalRequired === 0 ? 0 : Math.round((filled / totalRequired) * 100);
};